import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
import useIsMobile from 'hooks/use-is-mobile';
import { OPTIMIZELY_VARIATION_REFRESHED, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
function isParkingTypeIncludedInRevamp(parkingType) {
    const isMatchingParkingType = parkingType === 'transient' ||
        parkingType === 'monthly' ||
        parkingType === 'event' ||
        parkingType === 'power_booking';
    return isMatchingParkingType;
}
// Experiment hook to determine if the search revamp should be shown
export const useSearchRevampExperiment = () => {
    const isMobile = useIsMobile();
    const parkingType = useSelector(getParkingType);
    const isMatchingParkingType = isParkingTypeIncludedInRevamp(parkingType);
    const selectedVariation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_DESKTOP_WEB_SEARCH_REVAMP);
    const showDesktopRevampedVariation = selectedVariation === OPTIMIZELY_VARIATION_REFRESHED;
    if (isMobile) {
        return isMatchingParkingType;
    }
    return showDesktopRevampedVariation;
};
